import { z } from 'zod';

export const approveDeviceAuthorizationSchema = z.object({
  device_authorization_id: z.uuid('Valid device authorization ID is required'),
});

export type ApproveDeviceAuthorizationPayload = z.infer<typeof approveDeviceAuthorizationSchema>;
